import { Box, Stack, Typography } from '@mui/material';
import { useRosterState } from 'amazon-chime-sdk-component-library-react';
import { FormattedMessage } from 'react-intl';

import AttendeeCell from './attendeeCell';

function MeetingAttendees() {
  const { roster: allRoster } = useRosterState();

  return (
    <Box>
      <Typography
        sx={{
          fontSize: '20px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '125%',
          marginBottom: '24px',
        }}
      >
        <FormattedMessage defaultMessage='Attendees' />
      </Typography>
      <Stack gap={1}>
        {Object.values(allRoster)
          .filter(
            (roster) => !roster.externalUserId?.startsWith('aws:MediaPipeline'),
          )
          .map((roster) => (
            <AttendeeCell
              key={roster.chimeAttendeeId}
              attendeeID={roster.chimeAttendeeId}
            />
          ))}
      </Stack>
    </Box>
  );
}

export default MeetingAttendees;
